import classNames from 'classnames';
import React from 'react';

interface ContainerProps {
  children: any;
  noPaddingTop?: boolean;
  mobileFullWidth?: boolean;
}

const Container = ({ children, noPaddingTop, mobileFullWidth }: ContainerProps) => {
  return (
    <div
      className={classNames('container', {
        'container--no-padding-top': noPaddingTop,
        'container--mobile-full-width': mobileFullWidth,
      })}
    >
      {children}
    </div>
  );
};

export default Container;
